<template>
	<div class="index">
		<div class="topbanner" ref='yuansu'>
			<router-link tag="a" :to="{name:'introduce'}">
				<img src="../static/imgs/index/banner.png" alt="">
			</router-link>
		</div>
		<div class="preface">
			<router-link tag="a" :to="{name:'introduce'}">
				<img src="../static/imgs/index/preface.png" alt="">
			</router-link>
		</div>
		<div class="yearLine">
			<h3 class="title"><img src="../static/imgs/index/tit1.png" alt=""></h3>
			<div class="yearBox">
				<span class="year50"><img src="../static/imgs/index/yearTime/year50.png"></span>
				<ul>
					<li class="liRight">
						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'czc'
						}
						}" class-="yearLink">
						<img src="../static/imgs/index/yearTime/member01.png" alt="">
						</router-link>
					</li>
					<li class="liLeft word02">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'mx'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member02.png" alt="">
						</router-link>
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'yzz'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member03.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'wys'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member04.png" alt="">
						</router-link>
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'zhd'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member05.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'jyx'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member06.png" alt="">
						</router-link>
					</li>
					<li class="liCenter">
						<img src="../static/imgs/index/yearTime/year60.png" alt="">
					</li>
					<li class="liRight word07">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'lhn'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member07.png" alt="">
						</router-link>
					</li>
					<li class="liLeft word02">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'lj'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member08.png" alt="">
						</router-link>
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'dsp'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member09.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'cfx'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member10.png" alt="">
						</router-link>
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'fzy'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member11.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'ljy'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member12.png" alt="">
						</router-link>
					</li>
					<li class="liCenter">
						<img src="../static/imgs/index/yearTime/year70.png" alt="">
					</li>
					<li class="liRight">
						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'wsq'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member13.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'hbj'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member14.png" alt="">
						</router-link>
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'zsq'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member15.png" alt="">
						</router-link>
					</li>
					<li class="liLeft">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'yjc'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member16.png" alt="">
						</router-link>
					</li>
					<li class="liCenter">
						<img src="../static/imgs/index/yearTime/year80.png" alt="">
					</li>
					<li class="liRight">

						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'qzz'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member17.png" alt="">
						</router-link>
					</li>
					<li class="liCenter">
						<img src="../static/imgs/index/yearTime/year90.png" alt="">
					</li>
					<li class="liLeft word18">
						<router-link tag="a" :to="{
						name:'donation',
						query:{
							name:'zzk'
						}
						}" class-="yearLink">
							<img src="../static/imgs/index/yearTime/member18.png" alt="">
						</router-link>
					</li>
					<li class="round"><img src="../static/imgs/index/yearTime/round.png" alt=""></li>
					<li class="roundSmall"><img src="../static/imgs/index/yearTime/roundSmall.png" alt=""></li>
				</ul>
			</div>
		</div>
		<div class="unitBox">
			<h3 class="tit"><img src="../static/imgs/index/tit2.png" alt=""></h3>
		<div class="swiper-container">
		    <div class="swiper-wrapper">
		    	<div class="swiper-slide">
		    		<router-link tag="a" :to="{name:'proList1'}">
		    			<img src="../static/imgs/index/slide1.png" alt="">
		    		</router-link>
		    	</div>
		        <div class="swiper-slide">
		        	<router-link tag="a" :to="{name:'proList2'}">
		        		<img src="../static/imgs/index/slide2.png" alt="">
		        	</router-link>
		        </div>
		        <div class="swiper-slide">
		        	<router-link tag="a" :to="{name:'proList3'}">
		        		<img src="../static/imgs/index/slide3.png" alt="">
		        	</router-link>
		        </div>
		    </div>
		   <div class="swiper-pagination"></div>
		</div>
		</div>
		<div class="footer">
			<div>
				<p class="nameC">技术支持：雅昌文化集团</p>
				<p class="nameE">Techical  support：artron  cultre  group</p>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css';
	import { swiper, swiperSlide } from 'vue-awesome-swiper';
	export default {
		mounted(){
			var mySwiper = new Swiper('.swiper-container',{
                watchSlidesProgress: true,
                slidesPerView: 'auto',
                centeredSlides: true,
                loop: true,
                loopedSlides: 5,
                autoplay: false,
                pagination: {
                    el: '.swiper-pagination',
					type:'fraction'
                },
                on: {
                    progress: function (progress) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i);
                            var slideProgress = this.slides[i].progress;
                            var modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            var translate = slideProgress * modify * 100 + 'px';
                            var scale = 1 - Math.abs(slideProgress) / 5;
                            var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                            slide.css('zIndex', zIndex);
                            slide.css('opacity', 1);
                            if (Math.abs(slideProgress) > 3) {
                                slide.css('opacity', 0);
                            }
                        }
                    },
                    setTransition: function (transition) {
                        for (var i = 0; i < this.slides.length; i++) {
                            var slide = this.slides.eq(i)
                            slide.transition(transition);
                        }

                    }
                }
			})
		}
	}
</script>
<style scoped>
	.preface{
		width:1.83rem;
		height:1.83rem;
		position: absolute;
		top:.62rem;
		right:0;
	}
	img{max-width:100%;max-height:100%;}
	.preface img{width: 100%;}
	.yearLine{height:22.74rem;text-align: center;background:url("../static/imgs/index/time.png") no-repeat;background-size: auto 100%;padding-top: .49rem;}
	.yearLine .title{height:1.18rem;margin:0 auto;text-align: center;}
	.yearLine .title img{height:100%;}
	.yearBox {height:22.42rem;}
	.yearBox .year50{width:1.16rem;display:inline-block;margin-top: .5rem;position: relative;z-index: 1;}
	.yearBox ul{width:4.32rem;padding-top: .41rem;margin:0 auto;position: relative;}
	.yearBox ul:before{display:block;position: absolute;width:.025rem;left:50%;margin-left: -.0125rem;height:100%;content: '';background-color: #53422E;top:-.1rem;}
	.yearBox li{margin-bottom: .2rem;height:.6rem;position: relative;z-index: 1;}
	.yearBox .liLeft{text-align: left;}
	.yearBox .liRight{text-align: right;}
	.yearBox .word02{margin-left: .2rem;}
	.yearBox .word18{margin-left: -.075rem;}
	.yearBox .word07{margin-right: -.18rem;}
	.yearBox .round{margin-top: .2rem;height:1.28rem;}
	.yearBox .roundSmall{height:.18rem;margin-top: .2rem;}
	.unitBox{height:11.40rem;background:url("../static/imgs/index/unitBox.png") no-repeat;background-size: cover;padding-top: .71rem;}
	.unitBox .tit{height:1.05rem;text-align: center;margin-bottom: .92rem;}
	.swiper-container{
		width:6.34rem;
		overflow: inherit;
		height:8.86rem;
		overflow: hidden;
	}
	.swiper-slide{
		padding: 0;
		margin: 0;
		width:3.62rem;
		height:6.86rem;
		transform:scale(1);
		position: relative;
		display:-webkit-box;
		-webkit-box-pack:center;
		-webkit-box-align:center;
		-webkit-box-orient:horizontal;
		z-index: 1;

	}
	.swiper-slide img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	.swiper-pagination-bullets .swiper-pagination-bullet-active{
		background: #e6bb70!important;
	}
	.topbanner{
		width: 100%;
	}
	.topbanner img{
		width: 100%;
		height: 100%;
	}


	.footer{
		height:.85rem;
		width: 100%;
		background:url("../static/imgs/index/footer.png");
		padding-top: 2.15rem;
	}
	.footer p{
		text-align: center;
		color:#63482D;
	}
	.footer .nameC{font-size: .22rem;margin-bottom: .14rem;}
	.footer .nameE{font-size: .16rem;}
	.swiper-container-horizontal>.swiper-pagination-bullets, .swiper-pagination-custom, .swiper-pagination-fraction{bottom: 60px;}
	.swiper-pagination-fraction{color:#fff;font-size: .32rem;font-weight: normal;}

	.swiper-slide-duplicate-next,.swiper-slide-duplicate-prev{opacity: 0!important;}
	.swiper-pagination-fraction span:first-child{font-size: .5rem;}
</style>
<style>
	.swiper-pagination-current{font-size: .5rem;display:inline-block;	vertical-align: .15rem;margin-right: -.115rem;}
	.swiper-pagination-total{font-size: .32rem;display:inline-block;margin-left: -.025rem;}
</style>